(function () {
  function markLoaded(media) {
    media.classList.add("is-loaded");
  }

  function init(root) {
    root.querySelectorAll(".soft-dresses-product-grid [data-sd-product-media]").forEach(function (media) {
      if (media.dataset.sdProductLoadingReady) return;
      var image = media.querySelector("img");
      if (!image) return;

      media.dataset.sdProductLoadingReady = "true";

      if (image.complete && image.naturalWidth > 0) {
        markLoaded(media);
        return;
      }

      image.addEventListener("load", function () {
        markLoaded(media);
      }, { once: true });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });
})();
